// extracted by mini-css-extract-plugin
export default {"interviews":"Interviews-module__interviews__jxhlX","content":"Interviews-module__content__yxKgz"};